// @tennis-matches/services/auth
// Temporärer sichtbarer Auth-/Bootstrap-Debug (nur URL ?debugAuth=1 in der Web-App).
// Keine Tokens in State — nur Schrittmarken und redaktionierte Fehlermeldungen.

let __lastSuccessStep = "";
let __lastFailedStep = "";
/** @type {{ source: string, status: string|number, code: string, message: string }|null} */
let __lastRpcError = null;
let __bootstrapTimeoutMs = null;

function __redactSensitiveMessage(s) {
  let out = String(s || "");
  out = out.replace(/[A-Za-z0-9_-]{15,}\.[A-Za-z0-9_-]{15,}\.[A-Za-z0-9_-]{15,}/g, "[REDACTED_JWT]");
  out = out.replace(/access_token=[^&\s#]+/gi, "access_token=[REDACTED]");
  out = out.replace(/refresh_token=[^&\s#]+/gi, "refresh_token=[REDACTED]");
  out = out.replace(/provider_token=[^&\s#]+/gi, "provider_token=[REDACTED]");
  out = out.replace(/id_token=[^&\s#]+/gi, "id_token=[REDACTED]");
  return out.slice(0, 1200);
}

/**
 * @param {string} source
 * @param {unknown} err
 * @returns {{ source: string, status: string|number, code: string, message: string }}
 */
export function normalizeAuthDebugRpcError(source, err) {
  const e = err && typeof err === "object" ? err : {};
  const status = e.status ?? e.statusCode ?? "";
  const code = e.code ?? e.error ?? "";
  const message = __redactSensitiveMessage(e.message ?? e.msg ?? (typeof err === "string" ? err : String(err || "")));
  return { source: String(source || "unknown"), status, code, message };
}

export function beginAuthDebugBootstrap() {
  __lastSuccessStep = "";
  __lastFailedStep = "";
  __lastRpcError = null;
  __bootstrapTimeoutMs = null;
}

/** Erfolgreicher Meilenstein (überschreibt den letzten OK-Schritt). */
export function setAuthDebugStep(step) {
  const s = String(step || "").trim();
  if (!s) return;
  __lastSuccessStep = s;
}

/** Fehlgeschlagener Schritt; optional Fehlerobjekt (wird redaktioniert). */
export function setAuthDebugFailure(step, err, source = "") {
  const s = String(step || "").trim();
  if (s) __lastFailedStep = s;
  if (err != null) {
    __lastRpcError = normalizeAuthDebugRpcError(source || s || "error", err);
  }
}

/** Nur Fehlerdaten setzen (z. B. RPC), ohne failed-step zu ändern. */
export function setAuthDebugRpcError(source, err) {
  if (err == null) return;
  __lastRpcError = normalizeAuthDebugRpcError(source, err);
}

export function setAuthDebugBootstrapDeadline(ms) {
  const n = Number(ms);
  if (Number.isFinite(n) && n > 0) __bootstrapTimeoutMs = n;
}

export function getAuthDebugSnapshot() {
  return {
    lastSuccessStep: __lastSuccessStep || "",
    lastFailedStep: __lastFailedStep || "",
    lastRpcError: __lastRpcError,
    bootstrapTimeoutMs: __bootstrapTimeoutMs,
  };
}

/** Location ohne Hash und ohne sensible Query-Parameter (nie vollständigen Hash ausgeben). */
export function getSanitizedLocationHrefForDebug() {
  if (typeof window === "undefined") return "";
  try {
    const u = new URL(window.location.href);
    u.hash = "";
    const kill = new Set([
      "code",
      "state",
      "access_token",
      "refresh_token",
      "provider_token",
      "id_token",
      "token_type",
      "expires_in",
    ]);
    for (const k of [...u.searchParams.keys()]) {
      const lk = String(k || "").toLowerCase();
      if (kill.has(lk) || lk.includes("token")) u.searchParams.delete(k);
    }
    const qs = u.searchParams.toString();
    return `${u.origin}${u.pathname}${qs ? `?${qs}` : ""}`;
  } catch {
    return "";
  }
}

export function isAuthDebugUrlEnabled() {
  try {
    if (typeof window === "undefined") return false;
    return new URLSearchParams(window.location.search || "").get("debugAuth") === "1";
  } catch {
    return false;
  }
}
